import React, { ForwardedRef, forwardRef, useCallback } from 'react'
import {
  GestureResponderEvent,
  PressableProps,
  Pressable as RNPressable,
  TouchableOpacity,
  TouchableOpacityProps,
  View,
} from 'react-native'

import { publishEvent } from '@zet/analytics'
import { EventPayload } from '@zet/analytics/types'
import { styled } from 'nativewind'

type IPressable =
  | (
      | ({
          opacity: true
        } & TouchableOpacityProps)
      | ({
          opacity?: false
        } & PressableProps)
    ) & {
      eventName?: string
      eventPayload?: EventPayload
      opacity?: boolean
    }

const Pressable = forwardRef<TouchableOpacity | typeof RNPressable, IPressable>(
  ({ eventName, eventPayload, onPress, opacity, ...restProps }, ref) => {
    const handleOnPress = useCallback(
      (args: GestureResponderEvent) => {
        if (onPress) {
          onPress(args)
        }
        if (eventName) {
          publishEvent(eventName, eventPayload)
        }
      },
      [onPress, eventName, eventPayload]
    )
    if (opacity) {
      return (
        <TouchableOpacity
          ref={ref as ForwardedRef<TouchableOpacity>}
          onPress={handleOnPress}
          {...(restProps as Omit<TouchableOpacityProps, 'onPress'>)}
        ></TouchableOpacity>
      )
    }
    return (
      <RNPressable
        onPress={handleOnPress}
        {...restProps}
        ref={ref as ForwardedRef<View>}
      />
    )
  }
)

Pressable.displayName = 'Pressable'

const _Pressable = React.memo(styled(Pressable))

export default React.memo(styled(Pressable))

export { _Pressable as Pressable }
